import { call, put, takeLatest } from 'redux-saga/effects';
import { ApiResponse } from '../../api/request';
import { errorRoomsAction, getRoomsAction, setRoomsAction } from '../../store/customers/rooms-list.store';
import { productListAPI } from '../../api/provider/product/product-provider';
function* getRoomsSaga() {

  try {
    const roomsAndServicesResponse: ApiResponse | null = yield call(productListAPI);
    yield put(setRoomsAction(roomsAndServicesResponse))
  } catch (error: any) {
    yield put(errorRoomsAction(error.localizedMessage))
  }
}

export function* roomsSagas() {
  yield takeLatest(getRoomsAction.type, getRoomsSaga);
}
